// ../base/src/emitter/RPCMethod.ts
var RPCMethod = class {
  account;
  crossNetworkChain;
  sessionKey;
  retryLimit = 2;
  detectTimeout = 1500;
  detectAndSetProvider = () => {
    const p = this.detectProvider();
    p.then((provider) => this.provider = provider).catch((err) => console.warn(err));
    return p;
  };
  setAccounts = (accounts) => {
    this.account = accounts?.[0];
  };
  getProvider = () => this.provider;
};
var RPCMethod_default = RPCMethod;
export {
  RPCMethod_default as default
};
